import { useRef, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import WaIcon from "@/components/whatsapp/WaIcon";
import { Camera, Trash2 } from "lucide-react";
import CustomerAvatar from "@/components/customers/CustomerAvatar";
import AvatarCropper from "@/components/customers/AvatarCropper";

export default function CustomerPhotoField({ customer, onChange }) {
    const [file, setFile] = useState(null);
    const ref = useRef(null);
    const [waBusy, setWaBusy] = useState(false);
    const fromWa = async () => {
        setWaBusy(true);
        try {
            const { data } = await api.post(`/admin/customers/${customer.id}/whatsapp-photo`);
            onChange(data.photo_url);
            toast.success("Fotoja u mor nga WhatsApp");
        } catch (e) {
            toast.error(e?.response?.data?.detail || "Nuk u mor fotoja");
        } finally {
            setWaBusy(false);
        }
    };
    return (
        <div className="flex items-center gap-4" data-testid="customer-photo-field">
            <CustomerAvatar customer={customer} size={72} testId="customer-photo-preview" />
            <div className="flex flex-wrap gap-2">
                <button type="button" onClick={() => ref.current?.click()} className="btn-outline !py-1.5 text-xs" data-testid="customer-photo-upload">
                    <Camera className="w-4 h-4" /> {customer.photo_url ? "Ndrysho foton" : "Shto foto"}
                </button>
                {customer.id && (
                    <button type="button" onClick={fromWa} disabled={waBusy} className="btn-outline !py-1.5 text-xs text-[#128C7E]" data-testid="customer-photo-from-wa">
                        <WaIcon className="w-4 h-4" /> {waBusy ? "Duke marrë…" : "Nga WhatsApp"}
                    </button>
                )}
                {customer.photo_url && (
                    <button type="button" onClick={() => onChange(null)} className="btn-outline !py-1.5 text-xs text-red-600" data-testid="customer-photo-remove">
                        <Trash2 className="w-4 h-4" /> Hiq
                    </button>
                )}
                <input
                    ref={ref}
                    type="file"
                    accept="image/*"
                    className="hidden"
                    onChange={(e) => { const f = e.target.files?.[0]; if (f) setFile(f); e.target.value = ""; }}
                    data-testid="customer-photo-input"
                />
            </div>
            {file && <AvatarCropper file={file} onCancel={() => setFile(null)} onDone={(url) => { onChange(url); setFile(null); }} />}
        </div>
    );
}
